import { MULTI_LANGUAGES_ENABLED, MULTI_LANGUAGES } from './../constants/main';

export const parseBoolean = (value: string = '') => {
    const normalizedValue = value.trim().toLowerCase();

    if (normalizedValue === 'true' || normalizedValue === '1') {
        return true;
    }

    if (normalizedValue === 'false' || normalizedValue === '0') {
        return false;
    }

    return undefined;
};

export const decodeFromBase64 = <T>(str: string): T => {
    if (!str) return {} as T;

    try {
        // try base64 string, legacy
        return JSON.parse(atob(str));
    } catch (error: any) {
        // lets try non base64 string
        try {
            return JSON.parse(`{${str}}`);
        } catch (error: any) {
            console.log(`__Unknown string format for decoding and parsing: ${error}`);
            return {} as T;
        }
    }
};

export const deferredButtonClick = (id: string, timeout: number = 100) => {
    setTimeout(() => {
        try {
            const btn = document.getElementById(id);
            // not working .dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            btn.click();
        } catch (error: any) {}
    }, timeout);
};

export const urlHasLanguagePrefixRegex = MULTI_LANGUAGES_ENABLED
    ? new RegExp(`^/(${MULTI_LANGUAGES.join('|')})(/|$)`)
    : null;

export const removeLanguageFromPathname = (pathname: string): string => {
    // APP-19216
    if (urlHasLanguagePrefixRegex) {
        return pathname.replace(urlHasLanguagePrefixRegex, '/');
    }
    return pathname;
};
